import script from "./ovr.vue?vue&type=script&setup=true&lang=js"
export * from "./ovr.vue?vue&type=script&setup=true&lang=js"

import "./ovr.vue?vue&type=style&index=0&id=e57a48f0&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e57a48f0"]])

export default __exports__